// Shared helper: authenticated PDF fetch → blob → open in new tab.
// Used by AuditHubPage, CashFlowPage, and any future report/PDF trigger.
export async function openPdf(path) {
  const backend = process.env.REACT_APP_BACKEND_URL || "";
  const token = localStorage.getItem("token");
  const res = await fetch(`${backend}${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: "include",
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
